export var getCategory = function (card) {
    switch (card.kind) {
        case "Basic":
            return "Artikel";
        case "Labeled":
            return "Doe mee";
        case "Video":
            return "Video";
        case "Ticket":
            return "Ticket";
        case "Text":
            return "Tekst";
        default:
            return "Artikel";
    }
};
